import axiosClient from "../axios/axiosClient";

export function getLicenseCategories() {
  return axiosClient.get("/license-categories");
}

export function getLicenseCategory(licenseCategoryId) {
  return axiosClient.get(`/license-categories/${licenseCategoryId}`);
}

export function createLicenseCategory(data) {
  return axiosClient.post("/license-categories", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export const updateLicenseCategory = (licenseCategoryId, data) => {
  return axiosClient.put(`/license-categories/${licenseCategoryId}`, data);
};

export function deleteLicenseCategory(licenseCategoryId) {
  return axiosClient.delete(`/license-categories/${licenseCategoryId}`);
}
